import ApiService from '@/api/ApiServices';

const CompatibilityServices = {
  async getDataSite(url) {
    ApiService.removeHeader();
    const response = await ApiService.get(url);
    return response;
  },
  async getCompatibilityTypes(header) {
    ApiService.setHeader();
    const response = await ApiService.get('/compatibility-types', header);
    return response;
  },
  async getArticleTypes(header, azIso) {
    const response = await ApiService.get(`/compatibility-types/${azIso}/article-types`, header);
    return response;
  },
  async getBrands(header, azIso, reference) {
    const response = await ApiService.get(`/compatibility-types/${azIso}/article-types/${reference}/brands`, header);
    return response;
  },
  async getIumodels(header, azIso, reference, brand) {
    const response = await ApiService.get(`/compatibility-types/${azIso}/article-types/${reference}/brands/${brand}/iumodels`, header);
    return response;
  },
  async getResult(header, azIso, reference, brand, iumodel) {
    const response = await ApiService.get(
      `/compatibility-types/${azIso}/article-types/${reference}/brands/${brand}/iumodels/${iumodel}`,
      header,
    );
    return response;
  },
};

export default CompatibilityServices;
